module.exports = __webpack_public_path__ + "img/trash-arrow-up-solid.348ae3c7.svg";